module.exports = __webpack_public_path__ + "static/media/ost_4.95bcadd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ost_4.png
// module id = 1044
// module chunks = 0